import Box from '@mui/material/Box';
import React from 'react';

export interface DisabledBoxProps {
  value: string | number;
}

const DisabledBox: React.FC<DisabledBoxProps> = ({ value }): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        boxShadow: '0px 1px 2px 0px #0000000D',
        height: '40px',
        padding: '8px 12px',
        fontFamily: 'Poppins',
        fontSize: '14px',
        marginBottom: '8px'
      }}
    >
      {value}
    </Box>
  );
};

export default DisabledBox;
